webpackJsonp([13],{

/***/ 1193:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1194);


/***/ }),

/***/ 1194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(1195);

var _browseBar = __webpack_require__(1196);

var _browseBar2 = _interopRequireDefault(_browseBar);

var _browseDesigns = __webpack_require__(1197);

var _browseDesigns2 = _interopRequireDefault(_browseDesigns);

var _detachedDropdown = __webpack_require__(148);

var _detachedDropdown2 = _interopRequireDefault(_detachedDropdown);

var _designGrid = __webpack_require__(1198);

var _designGrid2 = _interopRequireDefault(_designGrid);

var _filterList = __webpack_require__(1199);

var _filterList2 = _interopRequireDefault(_filterList);

var _freezeScrolling = __webpack_require__(1200);

var _freezeScrolling2 = _interopRequireDefault(_freezeScrolling);

var _like = __webpack_require__(151);

var _like2 = _interopRequireDefault(_like);

var _like3 = __webpack_require__(150);

var _like4 = _interopRequireDefault(_like3);

var _megaDrawer = __webpack_require__(1201);

var _megaDrawer2 = _interopRequireDefault(_megaDrawer);

var _pagination = __webpack_require__(1202);

var _pagination2 = _interopRequireDefault(_pagination);

var _scrollDistanceTrigger = __webpack_require__(1203);

var _scrollDistanceTrigger2 = _interopRequireDefault(_scrollDistanceTrigger);

var _smallScreenOffCanvasFilters = __webpack_require__(393);

var _smallScreenOffCanvasFilters2 = _interopRequireDefault(_smallScreenOffCanvasFilters);

var _tagFilter = __webpack_require__(1204);

var _tagFilter2 = _interopRequireDefault(_tagFilter);

var _toggleVisible = __webpack_require__(160);

var _toggleVisible2 = _interopRequireDefault(_toggleVisible);

var _updateProperty = __webpack_require__(1205);

var _updateProperty2 = _interopRequireDefault(_updateProperty);

var _updateText = __webpack_require__(1206);

var _updateText2 = _interopRequireDefault(_updateText);

var _dropdownRepositioner = __webpack_require__(177);

var _dropdownRepositioner2 = _interopRequireDefault(_dropdownRepositioner);

var _htmlUpdater = __webpack_require__(178);

var _htmlUpdater2 = _interopRequireDefault(_htmlUpdater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    (0, _jquery2.default)(document).on('click', function (e) {
        (0, _jquery2.default)(this).trigger('uiCloseMultiSelectDropdown', { target: e.target });
        (0, _jquery2.default)(this).trigger('uiCloseSelectDropdown', { target: e.target });
        (0, _jquery2.default)(this).trigger('uiHideToggleVisible', { target: e.target });
        (0, _jquery2.default)(this).trigger('uiBodyClick', { target: e.target });
    });

    _browseBar2.default.attachTo('[data-browse-bar]');

    _browseDesigns2.default.attachTo(document, {
        baseUrl: '/discover',
        xhrUrl: '/discover/xhr/designs',
        filterTypes: {
            category: 'array',
            industry: 'array',
            tags: 'array',
            'admin-tags': 'array',
            language: 'array',
            'max-age': '',
            page: ''
        }
    });

    _designGrid2.default.attachTo('[data-design-grid]');

    var dropdowns = _detachedDropdown2.default.createAll('[data-detached-dropdown]');

    _filterList2.default.attachTo('[data-filter-list]');

    // Always position sticky with javascript, not CSS
    // https://github.com/filamentgroup/fixed-sticky#using-the-polyfill-instead-of-native
    window.FixedSticky.tests.sticky = false;
    (0, _jquery2.default)('[data-mega-drawer]').fixedsticky();

    (0, _jquery2.default)('[data-flight-like-button]').each(function () {
        _like2.default.attachTo(this, {
            likeUrl: (0, _jquery2.default)(this).data('like-url')
        });
    });

    _freezeScrolling2.default.attachTo('body', {
        scrollingSelector: '[data-scroll-freeze]'
    });

    (0, _jquery2.default)('[data-small-screen-off-canvas-filters-button]').on('click', function () {
        var $self = (0, _jquery2.default)(this);
        (0, _jquery2.default)(document).trigger('uiActivateSmallScreenOffCanvasFilters', {
            name: $self.attr('data-small-screen-off-canvas-filters-button-name')
        });
    });

    (0, _jquery2.default)('[data-login-signup-like-button]').on('click', function () {
        (0, _jquery2.default)(document).trigger('uiLikeButtonClicked');
    });

    _like4.default.attachTo('[data-flight-like-button]');

    _scrollDistanceTrigger2.default.attachTo(window, {
        triggeredEvent: 'uiCloseMegaDrawer',
        triggerAfterDistance: 250,
        resetTime: 1000
    });

    _smallScreenOffCanvasFilters2.default.attachTo('[data-small-screen-off-canvas-filters]');

    _tagFilter2.default.attachTo('[data-tag-editor-design-tags]', {
        filterName: 'tags'
    });

    _toggleVisible2.default.attachTo('[data-toggle-visible]');

    _megaDrawer2.default.attachTo('[data-mega-drawer]', {
        defaultTab: 'category'
    });

    _pagination2.default.attachTo('[data-pagination]');

    _updateText2.default.attachTo('[data-update-text="header"]', {
        dataKey: 'page_header_text',
        eventName: 'dataPageHeaderUpdate',
        fade: true
    });

    _updateText2.default.attachTo('head > title', {
        dataKey: 'page_title_text',
        eventName: 'dataPageHeaderUpdate',
        fade: false
    });

    _updateText2.default.attachTo('head > meta[property="og:title"]', {
        dataKey: 'page_title_text',
        eventName: 'dataPageHeaderUpdate',
        fade: false
    });

    _updateProperty2.default.attachTo('head > meta[name="twitter:title"]', {
        dataKey: 'page_title_text',
        eventName: 'dataPageHeaderUpdate',
        property: 'content'
    });

    (0, _jquery2.default)('[data-tag-input]').change(function (e) {
        e.preventDefault();
    });

    _htmlUpdater2.default.attachTo('[data-login-signup-container]', {
        eventName: 'uiLikeButtonClicked',
        templateSelector: '[data-update-html-template="login-or-signup"]'
    });

    _dropdownRepositioner2.default.attachTo('[data-login-signup-like-button]', {
        eventName: 'uiLikeButtonClicked',
        dropdowns: dropdowns
    });
}); // eslint-disable-line no-restricted-imports

/***/ }),

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {;(function( win, $ ) {

	function featureTest( property, value, noPrefixes ) {
		// Thanks Modernizr! https://github.com/phistuck/Modernizr/commit/3fb7217f5f8274e2f11fe6cfeda7cfaf9948a1f5
		var prop = property + ':',
			el = document.createElement( 'test' ),
			mStyle = el.style;

		if( !noPrefixes ) {
			mStyle.cssText = prop + [ '-webkit-', '-moz-', '-ms-', '-o-', '' ].join( value + ';' + prop ) + value + ';';
		} else {
			mStyle.cssText = prop + value;
		}
		return mStyle[ property ].indexOf( value ) !== -1;
	}

	function getPx( unit ) {
		return parseInt( unit, 10 ) || 0;
	}

	var uniqueIdCounter = 0;

	var S = {
		classes: {
			plugin: 'fixedsticky',
			active: 'fixedsticky-on',
			inactive: 'fixedsticky-off',
			clone: 'fixedsticky-dummy',
			withoutFixedFixed: 'fixedsticky-withoutfixedfixed'
		},
		keys: {
			offset: 'fixedStickyOffset',
			position: 'fixedStickyPosition',
			id: 'fixedStickyId'
		},
		tests: {
			sticky: featureTest( 'position', 'sticky' ),
			fixed: featureTest( 'position', 'fixed', true )
		},
		// Thanks jQuery!
		getScrollTop: function() {
			var prop = 'pageYOffset',
				method = 'scrollTop';
			return win ? (prop in win) ? win[ prop ] :
				win.document.documentElement[ method ] :
				win.document.body[ method ];
		},
		bypass: function() {
			// Check native sticky, check fixed and if fixed-fixed is also included on the page and is supported
			return ( S.tests.sticky && !S.optOut ) ||
				!S.tests.fixed ||
				win.FixedFixed && !$( win.document.documentElement ).hasClass( 'fixed-supported' );
		},
		update: function( el ) {
			if( !el.offsetWidth ) { return; }

			var $el = $( el ),
				height = $el.outerHeight(),
				initialOffset = $el.data( S.keys.offset ),
				scroll = S.getScrollTop(),
				isAlreadyOn = $el.is( '.' + S.classes.active ),
				toggle = function( turnOn ) {
					$el[ turnOn ? 'addClass' : 'removeClass' ]( S.classes.active )
						[ !turnOn ? 'addClass' : 'removeClass' ]( S.classes.inactive );
				},
				viewportHeight = $( window ).height(),
				position = $el.data( S.keys.position ),
				skipSettingToFixed,
				elTop,
				elBottom,
				$parent = $el.parent(),
				parentOffset = $parent.offset().top,
				parentHeight = $parent.outerHeight();

			if( initialOffset === undefined ) {
				initialOffset = $el.offset().top;
				$el.data( S.keys.offset, initialOffset );
				$el.after( $( '<div>' ).addClass( S.classes.clone ).height( height ) );
			} else {
				$el.next( '.' + S.classes.clone ).height( height );
			}

			if( !position ) {
				// Some browsers require fixed/absolute to report accurate top/left values.
				skipSettingToFixed = $el.css( 'top' ) !== 'auto' || $el.css( 'bottom' ) !== 'auto';

				if( !skipSettingToFixed ) {
					$el.css( 'position', 'fixed' );
				}

				position = {
					top: $el.css( 'top' ) !== 'auto',
					bottom: $el.css( 'bottom' ) !== 'auto'
				};

				if( !skipSettingToFixed ) {
					$el.css( 'position', '' );
				}

				$el.data( S.keys.position, position );
			}

			function isFixedToTop() {
				var offsetTop = scroll + elTop;

				// Initial Offset Top
				return initialOffset < offsetTop &&
					// Container Bottom
					offsetTop + height <= parentOffset + parentHeight;
			}

			function isFixedToBottom() {
				// Initial Offset Top + Height
				return initialOffset + ( height || 0 ) > scroll + viewportHeight - elBottom &&
					// Container Top
					scroll + viewportHeight - elBottom >= parentOffset + ( height || 0 );
			}

			elTop = getPx( $el.css( 'top' ) );
			elBottom = getPx( $el.css( 'bottom' ) );

			if( position.top && isFixedToTop() || position.bottom && isFixedToBottom() ) {
				if( !isAlreadyOn ) {
					toggle( true );
				}
			} else {
				if( isAlreadyOn ) {
					toggle( false );
				}
			}
		},
		destroy: function( el ) {
			var $el = $( el );
			if (S.bypass()) {
				return $el;
			}

			return $el.each(function() {
				var $this = $( this );
				var id = $this.data( S.keys.id );
				$( win ).unbind( '.fixedsticky' + id );

				$this
					.removeData( [ S.keys.offset, S.keys.position, S.keys.id ] )
					.removeClass( S.classes.active )
					.removeClass( S.classes.inactive )
					.next( '.' + S.classes.clone ).remove();
			});
		},
		init: function( el ) {
			var $el = $( el );

			if( S.bypass() ) {
				return $el;
			}

			return $el.each(function() {
				var _this = this;
				var id = uniqueIdCounter++;
				$( this ).data( S.keys.id, id );

				$( win ).bind( 'scroll.fixedsticky' + id, function() {
					S.update( _this );
				}).trigger( 'scroll.fixedsticky' + id );

				$( win ).bind( 'resize.fixedsticky' + id , function() {
					if( $el.is( '.' + S.classes.active ) ) {
						S.update( _this );
					}
				});
			});
		}
	};

	win.FixedSticky = S;

	// Plugin
	$.fn.fixedsticky = function( method ) {
		if ( typeof S[ method ] === 'function') {
			return S[ method ].call( S, this);
		} else if ( typeof method === 'object' || ! method ) {
			return S.init.call( S, this );
		} else {
			throw new Error( 'Method `' +  method + '` does not exist on jQuery.fixedsticky' );
		}
	};

	// Add fallback when fixed-fixed is not available.
	if( !win.FixedFixed ) {
		$( win.document.documentElement ).addClass( S.classes.withoutFixedFixed );
	}

})( window, jQuery );

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _doT = __webpack_require__(56);

var _doT2 = _interopRequireDefault(_doT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports
function BrowseBar() {
    this.defaultAttrs({
        filters: '[data-active-filters]',
        filter: '[data-filter-pill-open-drawer]',
        'filter-close': '[data-filter-pill-close-name]',
        'all-designs-pill': '[data-all-designs-pill]',
        'filter-template': '[data-browse-bar-filter-template]',
        'all-designs-template': '[data-all-designs-template]'
    });

    this.after('initialize', function () {
        this.on(document, 'uiMegaDrawerFilterChange', this.updateFilters);
        this.on('click', {
            filter: this.toggleMegaDrawerOpen,
            'filter-close': this.deactivateFilter,
            'all-designs-pill': this.toggleMegaDrawerDefault
        });

        this.on(document, 'dataFilterChange', this.updateFilters);
    });

    this.updateFilters = function (event, data) {
        var self = this;
        var filtersHTML = '';
        var filters = data.filters;

        // FIXME: Use Object.keys
        for (var filterIndex in filters) {
            // eslint-disable-line
            var filter = filters[filterIndex];
            if (Array.isArray(filter)) {
                for (var i = 0, l = filter.length; i < l; i += 1) {
                    filtersHTML += self.buildButton({
                        category: filterIndex,
                        name: filter[i].title,
                        value: filter[i].value
                    });
                }
            } else if (filterIndex !== 'page' && filter.value) {
                filtersHTML += self.buildButton({
                    category: filterIndex,
                    name: filter.title,
                    value: filter.value
                });
            }
        }

        if (!filtersHTML) {
            filtersHTML = this.select('all-designs-template').html();
        }

        this.select('filters').html(filtersHTML);
    };

    this.buildButton = function (el) {
        var template = _doT2.default.template(this.select('filter-template').html());
        return template(el);
    };

    this.toggleMegaDrawerDefault = function () {
        (0, _jquery2.default)(document).trigger('uiMegaDrawerToggleDefault');
    };

    this.deactivateFilter = function (event, data) {
        // Stopping propagation to prevent body click closing the drawer
        event.stopPropagation();

        var filterName = (0, _jquery2.default)(data.el).attr('data-filter-pill-category');
        var filterTitle = (0, _jquery2.default)(data.el).attr('data-filter-pill-title');
        var filterValue = (0, _jquery2.default)(data.el).attr('data-filter-pill-close-name');

        this.trigger('uiRemoveFilters', {
            filters: [{
                name: filterName,
                title: filterTitle,
                value: filterValue
            }]
        });
    };

    this.toggleMegaDrawerOpen = function (event, data) {
        var filterCategory = (0, _jquery2.default)(data.el).attr('data-filter-pill-category');
        (0, _jquery2.default)(document).trigger('uiMegaDrawerTogglePanel', { category: filterCategory });
        (0, _jquery2.default)(document).trigger('uiActivateSmallScreenOffCanvasFilters', { name: 'filters' });
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(BrowseBar);

/***/ }),

/***/ 1197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _withHistory = __webpack_require__(392);

var _withHistory2 = _interopRequireDefault(_withHistory);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

// eslint-disable-line no-restricted-imports
function BrowseDesigns() {
    this.defaultAttrs({
        baseUrl: null,
        xhrUrl: null,
        filterTypes: null,
        filters: {}
    });

    this.after('initialize', function () {
        this.on(document, 'uiNeedsBrowseDesigns', this.getBrowseDesigns);

        this.on(document, 'uiInitFilters', this.initFilters);
        this.on(document, 'uiAddFilters', this.addFilters);
        this.on(document, 'uiRemoveFilters', this.removeFilters);
        this.on(document, 'uiRemoveAllFilters', this.removeAllFilters);
        this.on(document, 'uiHasFilterTitles', this.replaceFilters);

        this.on(window, 'popstate', this.historyPopped);
    });

    this.getBrowseDesigns = function () {
        _jquery2.default.ajax({
            type: 'GET',
            url: this.attr.xhrUrl,
            data: this.makeQueryString(),
            headers: {
                Accept: 'application/json'
            },
            success: function success(data) {
                (0, _jquery2.default)(document).trigger('dataBrowseDesignsSuccess', data);

                // Custom event to update ddo collection
                window.dispatchEvent(new CustomEvent('newDdoDesignCollectionAvailable', {
                    detail: JSON.parse(data.ddo_design_collection)
                }));

                (0, _jquery2.default)(document).trigger('dataPaginationUpdate', { pagination: data.pagination });
                (0, _jquery2.default)(document).trigger('dataCanonicalUrlUpdate', { url: data.canonical_url });
                (0, _jquery2.default)(document).trigger('dataPageHeaderUpdate', {
                    page_header_text: data.page_header_text,
                    page_title_text: data.page_title_text
                });
            }
        });
    };

    this.initFilters = function (event, data) {
        data.filters.forEach(function (el) {
            this.addElementToFilterData(el);
        }, this);
        this.setPageFilter(data);
    };

    this.setPageFilter = function (filterData) {
        if (!this.hasPageFilter(filterData)) {
            this.attr.filters.page = { value: '' };
        }
    };

    this.addFilters = function (event, data) {
        // Cache filter data to compare with updated filters later. stringify+parse = clone
        var oldFilters = JSON.parse(JSON.stringify(this.attr.filters));
        data.filters.forEach(function (el) {
            this.addElementToFilterData(el);
        }, this);

        this.setPageFilter(data);

        if (!this.compareObjects(oldFilters, this.attr.filters)) {
            this.emitFilterChange();
        }
    };

    this.replaceFilters = function (event, data) {
        this.attr.filters = data.filters;
        this.trigger('dataFilterChange', { filters: this.attr.filters });
    };

    this.hasPageFilter = function (data) {
        return data.filters.some(function (filter) {
            return filter.name === 'page' && +filter.value > 1;
        });
    };

    this.arrayContainsObject = function (array, object) {
        for (var i = 0; i < array.length; i += 1) {
            if (JSON.stringify(array[i]) === JSON.stringify(object)) {
                return true;
            }
        }
        return false;
    };

    this.createUniqueArray = function (array) {
        var _this = this;

        return array.reduce(function (p, c) {
            if (!_this.arrayContainsObject(p, c)) {
                p.push(c);
            }
            return p;
        }, []);
    };

    this.addElementToFilterData = function (el) {
        if (this.isArrayParam(el.name)) {
            if (this.attr.filters[el.name]) {
                this.attr.filters[el.name].push({
                    title: el.title,
                    value: el.value
                });
                this.attr.filters[el.name] = this.createUniqueArray(this.attr.filters[el.name]);
            } else {
                this.attr.filters[el.name] = [{
                    title: el.title,
                    value: el.value
                }];
            }
        } else {
            this.attr.filters[el.name] = {
                title: el.title,
                value: el.value
            };
        }
    };

    this.removeElementFromFilterData = function (el) {
        if (this.isArrayParam(el.name)) {
            if (this.attr.filters[el.name]) {
                this.removeElementFromFilterArray({
                    name: el.name,
                    value: el.value
                });
            }
        } else {
            this.attr.filters[el.name] = { value: '' };
        }
    };

    this.filterIndexInArray = function (array, object) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i].name === object.name && array[i].value === object.value) {
                return i;
            }
        }
        return false;
    };

    this.removeElementFromFilterArray = function (filter) {
        var index = this.filterIndexInArray(this.attr.filters[filter.name], {
            value: filter.value
        });
        if (index !== false) {
            this.attr.filters[filter.name].splice(index, 1);
        }
    };

    this.makeQueryString = function () {
        var filters = this.removeEmptyFilters(this.attr.filters);
        return this.filtersToQueryString(filters);
    };

    this.queryStringToJSON = function () {
        var _this2 = this;

        var pairs = location.search.slice(1).split('&');
        var result = {};
        var idx = void 0;

        var _loop = function _loop() {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            var pair = pairs[idx].split('=');
            var key = decodeURIComponent(pair[0].toLowerCase());
            var value = decodeURIComponent(pair[1] || '');

            if (key) {
                if (_this2.isArrayParam(key)) {
                    result[key] = result[key] || [];
                    value.split(',').forEach(function (el) {
                        result[key].push(el);
                    });
                } else {
                    result[key] = value;
                }
            }
        };

        for (idx in pairs) {
            _loop();
        }
        return result;
    };

    this.filtersToQueryString = function (filters) {
        var queries = [];
        for (var filtersIndex in filters) {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            var filter = filters[filtersIndex];
            var query = [];
            for (var filterIndex in filter) {
                // eslint-disable-line guard-for-in, no-restricted-syntax
                if (filter[filterIndex].value) {
                    query.push(filter[filterIndex].value);
                }
            }
            queries.push(filtersIndex + '=' + query.toString());
        }
        return queries.join('&');
    };

    this.isArrayParam = function (param) {
        return this.attr.filterTypes[param.replace('[]', '')] === 'array';
    };

    this.compareObjects = function (obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };

    this.removeFilters = function (event, data) {
        var _this3 = this;

        // Cache filter data to compare with updated filters later. stringify+parse = clone
        var oldFilters = JSON.parse(JSON.stringify(this.attr.filters));
        data.filters.forEach(function (el) {
            _this3.removeElementFromFilterData(el);
        });
        this.attr.filters.page = { value: '' };
        if (!this.compareObjects(oldFilters, this.attr.filters)) {
            this.emitFilterChange();
        }
    };

    this.removeEmptyFilters = function (filters) {
        var self = this;
        var cleanedFilters = {};
        var filtersIndex = void 0;
        var filter = void 0;

        for (filtersIndex in filters) {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            filter = filters[filtersIndex];

            if (self.isArrayParam(filtersIndex)) {
                for (var filterIndex in filter) {
                    // eslint-disable-line guard-for-in, no-restricted-syntax
                    var filterItem = filter[filterIndex];
                    if (filterItem.value && filterItem.value.length) {
                        cleanedFilters[filtersIndex] = cleanedFilters[filtersIndex] || [];
                        cleanedFilters[filtersIndex].push(filterItem);
                    }
                }
            } else if (filter.value && filter.value.length) {
                cleanedFilters[filtersIndex] = cleanedFilters[filtersIndex] || [];
                cleanedFilters[filtersIndex].push(filter);
            }
        }

        return cleanedFilters;
    };

    this.emitFilterChange = function () {
        this.updateHistory();
        this.getBrowseDesigns();
        this.trigger('dataFilterChange', { filters: this.attr.filters });
    };

    this.removeAllFilters = function () {
        for (var _key in this.attr.filters) {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            this.attr.filters[_key] = this.isArrayParam(_key) ? [] : '';
        }
        this.attr.filters.page = { value: '' };
        this.emitFilterChange();
    };

    // History

    this.historyPopped = function (data) {
        var filtersWithoutTitles = void 0;
        var newFilters = void 0;
        var query = void 0;
        var filtersToBe = void 0;

        if ('state' in data.originalEvent && data.originalEvent.state !== null) {
            query = this.queryStringToJSON();
            newFilters = this.filtersFromQuery(query);
            filtersWithoutTitles = this.filtersWithoutTitles(this.attr.filters);

            if (!this.compareObjects(filtersWithoutTitles, newFilters)) {
                filtersToBe = this.handleUndefinedQueryKeys(query, newFilters);
                this.attr.filters = filtersToBe;
                this.getBrowseDesigns();
            }

            this.trigger('dataNeedsFilterTitles', { filters: this.attr.filters });
        }
    };

    this.filtersFromQuery = function (query) {
        var key = void 0;
        var filters = Object.assign({}, this.attr.filters);
        // Set default values in case query does not have keys
        // E.G. Hitting browser back button from page 2.
        filters['max-age'] = { value: '' };
        filters.page = { value: '' };

        for (key in query) {
            // eslint-disable-line no-restricted-syntax
            if (this.isArrayParam(key)) {
                filters[key] = [];
                query[key].forEach(function (value) {
                    // eslint-disable-line no-loop-func, prefer-arrow-callback
                    filters[key].push({ value: value });
                }, this);
            } else {
                filters[key] = { value: query[key] };
            }
        }

        return filters;
    };

    // Return clone of this.attr.filters without titles so that
    // it can be compared with this.filtersFromQuery(query);
    this.filtersWithoutTitles = function (filters) {
        var key = void 0;
        var newFilters = Object.assign({}, filters);

        for (key in newFilters) {
            // eslint-disable-line no-restricted-syntax
            if (this.isArrayParam(key)) {
                newFilters[key].forEach(function (value) {
                    // eslint-disable-line no-loop-func, prefer-arrow-callback
                    delete value.title; // eslint-disable-line no-param-reassign
                    if (!newFilters[key] || !newFilters[key] === 1) {
                        newFilters[key] = { value: '' };
                    }
                });
            } else {
                delete newFilters[key].title;
            }
        }
        return newFilters;
    };

    // If a filter key isn't defined in query, set it as an empty array or string.
    this.handleUndefinedQueryKeys = function (query, filters) {
        var key = void 0;

        for (key in filters) {
            // eslint-disable-line no-restricted-syntax
            if (typeof query[key] === 'undefined') {
                filters[key] = this.isArrayParam(key) ? [] : { value: '' }; // eslint-disable-line no-param-reassign
            }
        }
        return filters;
    };

    this.updateHistory = function () {
        if (this.isHistoryApiSupported()) {
            this.pushHistory(this.attr.baseUrl + '?' + this.makeQueryString());
        } else {
            window.location = this.attr.baseUrl + '?' + this.makeQueryString();
        }
    };
}

exports.default = (0, _flightjs.component)(BrowseDesigns, _withHistory2.default);

/***/ }),

/***/ 1198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _doT = __webpack_require__(56);

var _doT2 = _interopRequireDefault(_doT);

var _like = __webpack_require__(150);

var _like2 = _interopRequireDefault(_like);

var _like3 = __webpack_require__(151);

var _like4 = _interopRequireDefault(_like3);

var _detachedDropdown = __webpack_require__(148);

var _detachedDropdown2 = _interopRequireDefault(_detachedDropdown);

var _dropdownRepositioner = __webpack_require__(177);

var _dropdownRepositioner2 = _interopRequireDefault(_dropdownRepositioner);

var _htmlUpdater = __webpack_require__(178);

var _htmlUpdater2 = _interopRequireDefault(_htmlUpdater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function DesignGrid() {
    this.defaultAttrs({
        grid: '[data-design-grid-grid]',
        template: '[data-design-grid-template]',
        'zero-state': '[data-design-grid-zero-state]',
        'open-mega-drawer-button': '[data-open-mega-drawer-button]'
    });

    this.after('initialize', function () {
        this.on(document, 'dataBrowseDesignsSuccess', this.buildDesigns);
        this.on('click', {
            'open-mega-drawer-button': this.openMegaDrawerPanel
        });
        (0, _jquery2.default)('body').on('click', '[data-login-signup-like-button]', function () {
            (0, _jquery2.default)(document).trigger('uiLikeButtonClicked');
        });
    });

    this.buildDesigns = function (event, data) {
        var self = this;
        var designs = data.designs;
        this.removeZeroState();
        this.select('grid').html('');
        if (designs.length > 0) {
            designs.forEach(function (el) {
                var design = self.buildDesign(el);
                self.select('grid').append(design);
            });
            this.attachLikeComponent();
            var dropdowns = this.attachDetachedDropdown();
            this.attachHtmlUpdater();
            this.attachDropdownRepositioner(dropdowns);
        } else {
            this.setZeroState();
        }
    };

    this.attachLikeComponent = function () {
        _like2.default.attachTo(this.$node.find('[data-flight-like-button]'));
        this.$node.find('[data-flight-like-button]').each(function () {
            _like4.default.attachTo(this, {
                likeUrl: (0, _jquery2.default)(this).data('like-url')
            });
        });
    };

    this.attachDetachedDropdown = function () {
        var dropdowns = _detachedDropdown2.default.createAll(this.$node.find('[data-detached-dropdown]'));
        return dropdowns;
    };

    this.attachHtmlUpdater = function () {
        _htmlUpdater2.default.attachTo('[data-login-signup-container]', {
            eventName: 'uiLikeButtonClicked',
            templateSelector: '[data-update-html-template="login-or-signup"]'
        });
    };

    this.attachDropdownRepositioner = function (dropdowns) {
        _dropdownRepositioner2.default.attachTo('[data-login-signup-like-button]', {
            eventName: 'uiLikeButtonClicked',
            dropdowns: dropdowns
        });
    };

    this.buildDesign = function (el) {
        var template = _doT2.default.template(this.select('template').html());
        return template(el);
    };

    this.setZeroState = function () {
        this.select('zero-state').removeAttr('data-hidden');
    };

    this.removeZeroState = function () {
        this.select('zero-state').attr('data-hidden', true);
    };

    this.openMegaDrawerPanel = function (event, data) {
        event.stopPropagation();
        var filterCategory = (0, _jquery2.default)(data.el).attr('data-open-mega-drawer-button-panel');
        (0, _jquery2.default)(document).trigger('uiMegaDrawerOpenPanel', { category: filterCategory });
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(DesignGrid);

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function FilterList() {
    this.defaultAttrs({
        input: '[data-filter-list-input]',
        item: '[data-filter-list-item]'
    });

    this.after('initialize', function () {
        this.on('input', {
            input: this.filterList
        });
    });

    this.filterList = function () {
        var inputText = this.select('input').val().toLowerCase();

        this.select('item').attr('data-filter-list-item', true).each(function () {
            if ((0, _jquery2.default)(this).text().toLowerCase().indexOf(inputText) === -1) {
                (0, _jquery2.default)(this).attr('data-filter-list-item', false);
            }
        });
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(FilterList);

/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function FreezeScrolling() {
    this.defaultAttrs({
        scrollingSelector: null
    });

    this.after('initialize', function () {
        this.on('mouseover', {
            scrollingSelector: this.freezeScrolling
        });

        this.on('mouseout', {
            scrollingSelector: this.defrostScrolling
        });
    });

    // Disable scrolling this element while scrolling on selected inner element
    this.freezeScrolling = function () {
        this.$node.css('overflow', 'hidden');
    };

    // Re-enable scrolling when not scrolling on selected inner element
    this.defrostScrolling = function () {
        this.$node.css('overflow', '');
    };
}

exports.default = (0, _flightjs.component)(FreezeScrolling);

/***/ }),

/***/ 1201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function MegaDrawer() {
    this.defaultAttrs({
        form: 'form',
        input: '[data-mega-drawer-filter-input]',
        toggle: '[data-mega-drawer-toggle]',
        tab: '[data-mega-drawer-tab-name]',
        panel: '[data-mega-drawer-panel-name]',
        panelClose: '[data-mega-drawer-close-panel-button]',
        panelDefault: '[data-mega-drawer-panel-default]',
        clearAllFilters: '[data-mega-drawer-clear-filters]',
        currentPage: '[data-current-page]',

        checkbox: 'input[type=checkbox]',
        radioButton: 'input[type=radio]',

        defaultTab: '',
        defaultURL: ''
    });

    this.after('initialize', function () {
        this.on('click', {
            toggle: this.toggleMegaDrawer,
            tab: this.tabClick,
            clearAllFilters: this.clearAllFilters,
            panelClose: this.deactivateTabs,

            input: this.selectFilter
        });

        this.on('uiOpenMegaDrawer', this.openMegaDrawer);
        this.on(document, 'uiCloseMegaDrawer', this.closeMegaDrawer);
        this.on(document, 'uiBodyClick', this.bodyClick);
        this.on(document, 'uiMegaDrawerToggleDefault', this.toggleDefaultTab);
        this.on(document, 'uiMegaDrawerTogglePanel', this.toggleTab);
        this.on(document, 'uiMegaDrawerOpenPanel', this.openTab);

        this.initFilters();

        this.on(document, 'dataFilterChange', this.filtersUpdate);
        this.on('uiTagFilterSelected', this.tagAdded);
        this.on('uiTagFilterDeleted', this.tagRemoved);
        this.on(document, 'uiPaginationChangePage', this.changePage);
        this.on(document, 'dataNeedsFilterTitles', this.addFilterTitlesToFilterData);
    });

    // Filter UI CRUD

    this.initFilters = function () {
        this.trigger('uiInitFilters', { filters: this.getCurrentFiltersArray() });
    };

    this.emitFilters = function () {
        this.trigger('uiAddFilters', { filters: this.getCurrentFiltersArray() });
    };

    this.getCurrentFiltersArray = function () {
        if (this.select('form').length) {
            var formArray = this.select('form').serializeArray();
            formArray.forEach(function (el, index) {
                var $input = (0, _jquery2.default)((0, _jquery2.default)('[name="' + el.name + '"][value="' + el.value + '"]')[0]);
                var inputTitle = $input.attr('data-mega-drawer-filter-title');
                if (inputTitle) {
                    formArray[index].title = inputTitle;
                }
            });
            return formArray;
        }
        return null;
    };

    this.filtersUpdate = function (event, data) {
        // FIXME: Rewrite using Object.keys
        for (var filtersIndex in data.filters) {
            // eslint-disable-line
            var filter = data.filters[filtersIndex];
            if (data.filters.hasOwnProperty(filtersIndex)) {
                // eslint-disable-line
                this.updateFilter({
                    name: filtersIndex,
                    filterItems: filter
                });
            }
        }
        this.updateClearAllFiltersButton(data.filters);
    };

    this.updateFilter = function (filter) {
        var inputs = this.getInputsByName(filter.name);
        inputs.prop('checked', false);

        if (_jquery2.default.isArray(filter.filterItems)) {
            filter.filterItems.forEach(function (filterItem) {
                inputs.filter('[value="' + filterItem.value + '"]').prop('checked', true);
            });
        } else {
            var value = filter.filterItems !== undefined ? filter.filterItems.value : filter.filterItems;
            inputs.filter('[value="' + value + '"]').prop('checked', true);
        }
    };

    this.getInputsByName = function (name) {
        return this.select('form').find('[name="' + name + '"]');
    };

    this.selectFilter = function (event, data) {
        if (data.el.checked) {
            this.trigger('uiAddFilters', {
                filters: [{
                    name: data.el.name,
                    title: (0, _jquery2.default)(data.el).attr('data-mega-drawer-filter-title'),
                    value: data.el.value
                }]
            });
        } else {
            this.trigger('uiRemoveFilters', {
                filters: [{
                    name: data.el.name,
                    title: (0, _jquery2.default)(data.el).attr('data-mega-drawer-filter-title'),
                    value: data.el.value
                }]
            });
        }
    };

    this.tagAdded = function (event, data) {
        this.trigger('uiAddFilters', {
            filters: [{
                name: data.filterName,
                title: data.tagName,
                value: data.tagName
            }]
        });
    };

    this.tagRemoved = function (event, data) {
        this.trigger('uiRemoveFilters', {
            filters: [{
                name: data.filterName,
                value: data.tagName
            }]
        });
    };

    this.updateClearAllFiltersButton = function (filters) {
        var filtersActive = false;

        // FIXME: Rewrite using Object.keys
        for (var filter in filters) {
            // eslint-disable-line
            if (filters.hasOwnProperty(filter)) {
                // eslint-disable-line
                if (filter !== 'page' && filters[filter]) {
                    filtersActive = true;
                }
            }
        }

        var clearAllFiltersButton = this.select('clearAllFilters');
        if (filtersActive) {
            clearAllFiltersButton.attr('data-active', 'true');
        } else {
            clearAllFiltersButton.attr('data-active', 'false');
        }
    };

    this.clearAllFilters = function () {
        this.trigger('uiRemoveAllFilters');
    };

    this.changePage = function (event, data) {
        this.trigger('uiAddFilters', {
            filters: [{
                name: 'page',
                value: data.page.toString()
            }]
        });
    };

    this.getFilterTitleByNameAndValue = function (name, value) {
        var $input = this.getInputsByName(name).filter('[value="' + value + '"]');
        return $input.attr('data-mega-drawer-filter-title') || $input.val();
    };

    this.addTitlesToFilterArray = function (filter, filterName) {
        var filterWithTitles = [];
        filter.forEach(function (filterValue) {
            var value = filterValue.value;
            var title = this.getFilterTitleByNameAndValue(filterName, value);
            filterWithTitles.push({
                value: value,
                title: title || value
            });
        }, this);
        return filterWithTitles;
    };

    this.addTitleToFilter = function (filter, filterName) {
        var value = filter.value;
        var title = this.getFilterTitleByNameAndValue(filterName, value);
        return {
            value: value,
            title: title
        };
    };

    this.addFilterTitlesToFilterData = function (event, data) {
        var filters = data.filters;
        var filtersWithTitles = {};

        // FIXME: Rewrite using Object.keys
        for (var filterName in filters) {
            // eslint-disable-line
            var filter = filters[filterName];
            if (_jquery2.default.isArray(filter)) {
                filtersWithTitles[filterName] = this.addTitlesToFilterArray(filter, filterName);
            } else if (filter.value) {
                filtersWithTitles[filterName] = this.addTitleToFilter(filter, filterName);
            } else {
                filtersWithTitles[filterName] = { value: '' };
            }
        }
        this.trigger('uiHasFilterTitles', { filters: filtersWithTitles });
    };

    // Open and close drawers/panels/etc

    this.openTab = function (category) {
        this.activateTab(category);
        this.openMegaDrawer();
    };

    this.toggleTab = function (event, data) {
        if (this.select('toggle').attr('data-active') === 'true') {
            var $panel = this.$node.find('[data-mega-drawer-panel-name="' + data.category + '"]');
            if ($panel.attr('data-active') === 'true') {
                this.closeMegaDrawer();
            } else {
                this.activateTab($panel.attr('data-mega-drawer-panel-name'));
            }
        } else {
            this.openTab(data.category);
        }
    };

    this.bodyClick = function (event, data) {
        if (!this.$node.is(data.target) && this.$node.has(data.target).length === 0) {
            this.closeMegaDrawer();
        }
    };

    this.toggleMegaDrawer = function () {
        if (this.$node.attr('data-active') === 'true') {
            this.closeMegaDrawer();
        } else {
            this.openMegaDrawer();
        }
    };

    this.tabClick = function (event, data) {
        this.activateTab((0, _jquery2.default)(data.el).attr('data-mega-drawer-tab-name'));
    };

    this.activateTab = function (tabName) {
        if (this.doesPanelExist(tabName)) {
            this.select('tab').attr('data-active', 'false');
            this.select('tab').filter('[data-mega-drawer-tab-name="' + tabName + '"]').attr('data-active', 'true');
            this.select('panel').attr('data-active', 'false');
            this.select('panel').filter('[data-mega-drawer-panel-name="' + tabName + '"]').attr('data-active', 'true');
        }
    };

    this.doesPanelExist = function (tabName) {
        return !!this.select('panel').filter('[data-mega-drawer-panel-name="' + tabName + '"]').length;
    };

    this.toggleDefaultTab = function () {
        if (this.attr.defaultTab) {
            this.activateTab(this.attr.defaultTab);
        }
        this.toggleMegaDrawer();
    };

    this.deactivateTabs = function () {
        this.select('tab').attr('data-active', 'false');
        this.select('panel').attr('data-active', 'false');
    };

    this.openMegaDrawer = function () {
        this.select('toggle').attr('data-active', 'true');
        this.$node.attr('data-active', 'true');
    };

    this.closeMegaDrawer = function () {
        this.select('toggle').attr('data-active', 'false');
        this.$node.attr('data-active', 'false');
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(MegaDrawer);

/***/ }),

/***/ 1202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function Pagination() {
    this.defaultAttrs({
        'page-button': '[data-page-number]'
    });

    this.after('initialize', function () {
        this.on('click', {
            'page-button': this.changePage
        });

        this.on(document, 'dataPaginationUpdate', this.updatePagination);
    });

    this.changePage = function (event, data) {
        event.preventDefault();
        (0, _jquery2.default)(document).trigger('uiPaginationChangePage', {
            page: (0, _jquery2.default)(data.el).attr('data-page-number')
        });
    };

    this.updatePagination = function (event, data) {
        this.$node.html(data.pagination);
        window.scrollTo(0, 0);
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(Pagination);

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function ScrollDistanceTrigger() {
    this.defaultAttrs({
        triggeredEvent: null,
        triggerAfterDistance: null,
        resetTime: null,

        scrollStart: undefined,
        scrollDistance: 0,
        scrollTimeout: undefined
    });

    this.after('initialize', function () {
        this.on('scroll', this.scroll);
    });

    // Initialize start position, check distance, trigger event if distance is reached
    this.scroll = function () {
        if (this.attr.scrollStart === undefined) {
            this.initializeScrollStart();
        }
        this.updateScrollDistance();
        this.setupTimeout();
        if (this.attr.scrollDistance > this.attr.triggerAfterDistance) {
            (0, _jquery2.default)(document).trigger(this.attr.triggeredEvent);
        }
    };

    // Set scroll start position to current scroll position
    this.initializeScrollStart = function () {
        this.attr.scrollStart = this.$node.scrollTop();
    };

    // Set scroll distance to difference between scroll start and current position
    this.updateScrollDistance = function () {
        this.attr.scrollDistance = Math.abs(this.attr.scrollStart - this.$node.scrollTop());
    };

    // Clear current timeout and reset
    this.setupTimeout = function () {
        window.clearTimeout(this.attr.scrollTimeout);
        this.attr.scrollTimeout = window.setTimeout(this.resetScrollStart.bind(this), this.attr.resetTime);
    };

    // Clear current timeout
    this.resetScrollStart = function () {
        this.attr.scrollStart = undefined;
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(ScrollDistanceTrigger);

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _tagEditor = __webpack_require__(199);

var _tagEditor2 = _interopRequireDefault(_tagEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TagFilter() {
    this.defaultAttrs({
        filterName: null
    });

    this.after('initialize', function () {
        _tagEditor2.default.attachTo(this.$node, {
            dataSource: this.$node.data('tag-data-source-url'),
            allowCreateTag: false,
            submitOnTagChange: false
        });

        this.on('uiSuggestionsSelected', this.tagSelected);
        this.on('uiTagDeleted', this.tagUnselected);
        this.on(document, 'dataFilterChange', this.filtersChanged);
    });

    this.tagSelected = function (e, data) {
        this.trigger('uiTagFilterSelected', {
            tagName: data.tagName,
            filterName: this.attr.filterName
        });
    };

    this.tagUnselected = function (e, data) {
        this.trigger('uiTagFilterDeleted', {
            tagName: data.tagName,
            filterName: this.attr.filterName
        });
    };

    this.filtersChanged = function (e, data) {
        var updatedTags = data.filters[this.attr.filterName] || [];
        this.trigger('uiReplaceTags', { tags: updatedTags });
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(TagFilter);

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function UpdateProperty() {
    this.defaultAttrs({
        dataKey: null,
        eventName: null,
        property: null
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.updateProperty);
    });

    this.updateProperty = function (e, data) {
        if (data[this.attr.dataKey]) {
            this.$node.prop(this.attr.property, data[this.attr.dataKey]);
        }
    };
}

exports.default = (0, _flightjs.component)(UpdateProperty);

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function UpdateText() {
    this.defaultAttrs({
        dataKey: null,
        eventName: null
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.updateText);
    });

    this.updateText = function (e, data) {
        var self = this;
        if (data[this.attr.dataKey]) {
            if (this.attr.fade) {
                this.$node.fadeOut(200, function () {
                    self.$node.text(data[self.attr.dataKey]);
                    self.$node.fadeIn(200);
                });
            } else {
                this.$node.text(data[this.attr.dataKey]);
            }
        }
    };
}

exports.default = (0, _flightjs.component)(UpdateText);

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function LikeButton() {
    this.defaultAttrs({
        currentLikeCount: '[data-like-count]'
    });

    this.getLikeCount = function () {
        return parseInt(this.select('currentLikeCount').text(), 10);
    };

    this.setLikeCount = function (count) {
        this.select('currentLikeCount').text(count);
    };

    this.isDesignLiked = function () {
        return this.$node.attr('data-liked') === 'true';
    };

    this.setDesignLiked = function (isLiked) {
        this.$node.attr('data-liked', '' + isLiked);
    };

    this.setLikeStatusAndCount = function (isLiked, likeCount) {
        this.setDesignLiked(isLiked);
        this.setLikeCount(likeCount);
    };

    this.onDesignLikedSuccess = function (e, data) {
        this.setLikeStatusAndCount(true, data.likeCount);
    };

    this.onDesignUnlikedSuccess = function (e, data) {
        this.setLikeStatusAndCount(false, data.likeCount);
    };

    this.toggle = function (e) {
        e.preventDefault();
        if (this.isDesignLiked()) {
            this.setLikeStatusAndCount(false, this.getLikeCount() - 1);
            this.trigger(this.$node, 'uiDesignUnliked');
        } else {
            this.setLikeStatusAndCount(true, this.getLikeCount() + 1);
            this.trigger(this.$node, 'uiDesignLiked');
        }
    };

    this.after('initialize', function () {
        this.on(this.$node, 'dataDesignLikedSuccess', this.onDesignLikedSuccess);
        this.on(this.$node, 'dataDesignUnlikedSuccess', this.onDesignUnlikedSuccess);

        this.on('click', this.toggle);
    });
}

exports.default = (0, _flightjs.component)(LikeButton);

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function LikeData() {
    this.defaultAttrs({
        likeUrl: null
    });

    this.likeDesign = function (e, data) {
        _jquery2.default.ajax({
            url: this.attr.likeUrl,
            data: data,
            type: 'POST',
            headers: { Accept: 'application/json' },
            success: function (successData) {
                this.$node.trigger('dataDesignLikedSuccess', successData);
            }.bind(this),
            error: function () {
                this.$node.trigger('dataDesignLikedError');
            }.bind(this)
        });
    };

    this.unlikeDesign = function (e, data) {
        _jquery2.default.ajax({
            url: this.attr.likeUrl,
            data: data,
            type: 'DELETE',
            headers: { Accept: 'application/json' },
            success: function (successData) {
                this.$node.trigger('dataDesignUnlikedSuccess', successData);
            }.bind(this),
            error: function () {
                this.$node.trigger('dataDesignUnlikedError');
            }.bind(this)
        });
    };

    this.after('initialize', function () {
        this.on(this.$node, 'uiDesignLiked', this.likeDesign);
        this.on(this.$node, 'uiDesignUnliked', this.unlikeDesign);
    });
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(LikeData);

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function ToggleVisible() {
    this.defaultAttrs({
        buttonSelector: '[data-toggle-visible-button]',
        elementSelector: '[data-toggle-visible-element]',
        hideOnBodyClickAttribute: 'data-toggle-visible-hide-on-body-click'
    });

    this.toggleVisible = function () {
        var $element = this.select('elementSelector');
        if ($element.is('[data-active]')) {
            this.hideElement();
        } else {
            this.showElement();
        }
    };

    this.hideElement = function () {
        this.select('buttonSelector').removeAttr('data-active');
        this.select('elementSelector').removeAttr('data-active');
    };

    this.showElement = function () {
        this.select('buttonSelector').attr('data-active', '');
        this.select('elementSelector').attr('data-active', '');
    };

    this.bodyClick = function (e, data) {
        if (this.$node.attr('data-toggle-visible-hide-on-body-click') !== 'false') {
            if (!this.$node.is(data.target) && this.$node.has(data.target).length === 0) {
                this.hideElement();
            }
        }
    };

    this.after('initialize', function () {
        this.on('click', {
            buttonSelector: this.toggleVisible
        });

        this.on(document, 'uiHideToggleVisible', this.bodyClick);
    });
}

exports.default = (0, _flightjs.component)(ToggleVisible);

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function DropdownRepositioner() {
    this.defaultAttrs({
        eventName: null,
        dropdowns: null
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.repositionDetachedDropdown);
    });

    this.repositionDetachedDropdown = function () {
        var dropdowns = this.attr.dropdowns;
        var clickTarget = this.$node[0];

        dropdowns.forEach(function (dropdown) {
            if (dropdown.$el[0].contains(clickTarget)) {
                dropdown.positionDropdown();
            }
        });
    };
}

exports.default = (0, _flightjs.component)(DropdownRepositioner);

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _doT = __webpack_require__(56);

var _doT2 = _interopRequireDefault(_doT);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

// eslint-disable-line no-restricted-imports
function HtmlUpdater() {
    this.defaultAttrs({
        eventName: null,
        templateSelector: null
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.updateHtml);
    });

    this.updateHtml = function () {
        var html = (0, _jquery2.default)(this.attr.templateSelector).html();
        var template = _doT2.default.template(html);
        this.$node.html(template);
    };
}

exports.default = (0, _flightjs.component)(HtmlUpdater);

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _flightjs2 = _interopRequireDefault(_flightjs);

var _flightWithChildComponents = __webpack_require__(248);

var _flightWithChildComponents2 = _interopRequireDefault(_flightWithChildComponents);

var _tagDisplay = __webpack_require__(200);

var _tagDisplay2 = _interopRequireDefault(_tagDisplay);

var _tagInput = __webpack_require__(201);

var _tagInput2 = _interopRequireDefault(_tagInput);

var _tagSuggestions = __webpack_require__(202);

var _tagSuggestions2 = _interopRequireDefault(_tagSuggestions);

var _remoteTagSuggestions = __webpack_require__(203);

var _remoteTagSuggestions2 = _interopRequireDefault(_remoteTagSuggestions);

var _localTagSuggestions = __webpack_require__(204);

var _localTagSuggestions2 = _interopRequireDefault(_localTagSuggestions);

var _doT = __webpack_require__(56);

var _doT2 = _interopRequireDefault(_doT);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

// eslint-disable-line no-restricted-imports
function TagEditor() {
    this.defaultAttrs({
        tagDivider: '\n',
        dataSource: '',
        dataSourceLocation: 'remote',
        submitOnTagChange: false,
        allowCreateTag: true,
        disallowDefault: false,
        caseSensitive: true,

        // Selectors
        inputSelector: '[data-tag-input]',
        displaySelector: '[data-tag-display]',
        suggestionsListSelector: '[data-tag-suggestions]',
        tagInputs: '[data-tag-editor-tag-inputs]',
        tagInputName: '[data-tag-editor-tag-input-name]',
        tagInput: '[data-tag-editor-tag-input]'
    });

    // Add tag-string from form element (textarea)
    this.addTagNameToForm = function (event, data) {
        var tagName = data.tagName;
        this.addTag(tagName);
        this.checkForMaxTags();
        this.select('inputSelector').focus();
        if (this.attr.submitOnTagChange) {
            this.$node.parents('form').submit();
        }
    };

    this.checkForMaxTags = function () {
        var tags = this.getTags();
        if (tags.length >= this.$node.attr('data-max-tags')) {
            this.select('inputSelector').prop('disabled', true).attr('placeholder', this.$node.attr('data-tag-editor-max-tags-msg'));
        } else {
            this.select('inputSelector').prop('disabled', false).attr('placeholder', this.$node.attr('data-tag-editor-add-tag'));
        }
    };

    // Read, split and broadcast existing tags
    this.provideExistingTags = function () {
        this.select('displaySelector').triggerHandler('uiExistingTagsAvailable', {
            existingTags: this.getTags()
        });
    };

    // Add existing tags, then delegate to suggestions list
    this.addExistingTags = function (event, data) {
        var dataWithExistingTags = data;
        dataWithExistingTags.existingTags = this.getTags();
        this.triggerSuggestionsListEvent(event, data);
    };

    // Remove tag-string from form element (textarea)
    this.removeTagNameFromForm = function (event, data) {
        var tagName = data.tagName.trim();
        this.removeTag(tagName);
        this.checkForMaxTags();
        if (this.attr.submitOnTagChange) {
            this.$node.parents('form').submit();
        }
    };

    // Trigger event on suggestion list, avoid bubbling
    this.triggerSuggestionsListEvent = function (event, data) {
        this.select('suggestionsListSelector').triggerHandler(event.type, data);
    };

    // Trigger event on suggestion list, avoid bubbling
    this.triggerInputEvent = function (event, data) {
        this.select('inputSelector').triggerHandler(event.type, data);
    };

    // Trigger event on suggestion list, avoid bubbling
    this.triggerDisplayEvent = function (event, data) {
        this.select('displaySelector').triggerHandler(event.type, data);
    };

    // Get a list of tags
    this.getTags = function () {
        var tags = [];
        this.select('tagInput').each(function () {
            tags.push(this.value);
        });
        return tags;
    };

    // Add tag to inputs
    this.addTag = function (tagName) {
        var tags = this.getTags();
        if (_jquery2.default.inArray(tagName, tags)) {
            var inputName = this.select('tagInputName').attr('data-tag-editor-tag-input-name');
            var templateInput = '<input type="hidden" name="{{!it.inputName}}" value="{{!it.tagName}}" data-tag-editor-tag-input="">';
            var template = _doT2.default.template(templateInput);
            var templateHTML = template({
                inputName: inputName,
                tagName: tagName
            });
            this.select('tagInputs').append(templateHTML);
        }
    };

    // Remove tag from input
    this.removeTag = function (tagName) {
        this.select('tagInput').filter('[value="' + tagName + '"]').remove();
    };

    this.replaceTags = function (event, data) {
        var self = this;
        var tags = data.tags || [];
        this.select('tagInputs').html('');
        tags.forEach(function (tag) {
            self.addTag(tag.value);
        });
        this.select('displaySelector').triggerHandler('uiReplaceTags', data);
    };

    // Check to see if text input value is in tags, if not, select it
    this.attemptSelectFromInput = function () {
        var tagName = this.select('inputSelector').val().trim();
        var tags = this.getTags();
        if (_jquery2.default.inArray(tagName, tags) === -1) {
            if (!this.attr.disallowDefault) {
                this.trigger('uiSuggestionsSelected', {
                    tagName: tagName
                });
                this.trigger('uiSuggestionsAbort', {
                    userString: ''
                });
            }
        }
    };

    this.after('initialize', function () {
        // Attach data components
        if (this.attr.dataSourceLocation === 'local') {
            _localTagSuggestions2.default.attachTo(this.$node, {
                caseSensitive: this.attr.caseSensitive
            });
        } else {
            _remoteTagSuggestions2.default.attachTo(this.$node, {
                dataSource: this.attr.dataSource
            });
        }

        // Attach ui components
        _tagDisplay2.default.attachTo(this.select('displaySelector'));
        _tagInput2.default.attachTo(this.select('inputSelector'), {
            caseSensitive: this.attr.caseSensitive
        });
        _tagSuggestions2.default.attachTo(this.select('suggestionsListSelector'), {
            allowCreateTag: this.attr.allowCreateTag,
            disallowDefault: this.attr.disallowDefault
        });

        // Remove tagname from from textarea, when deleted in display
        this.on('uiTagDeleted', this.removeTagNameFromForm);

        // Delegate keyboard events to suggestions list
        this.on('uiSuggestionsMoveUp', this.triggerSuggestionsListEvent);
        this.on('uiSuggestionsMoveDown', this.triggerSuggestionsListEvent);
        this.on('uiSuggestionsConfirm', this.triggerSuggestionsListEvent);
        this.on('uiSuggestionsAbort', this.triggerSuggestionsListEvent);

        // Select tag from text input if not already in tags
        this.on('uiAttemptSelectFromInput', this.attemptSelectFromInput);

        // Replace all inputs and tags with new data
        this.on('uiReplaceTags', this.replaceTags);

        // Add existing tags to suggestions data
        this.on('dataSuggestionsDataServed', this.addExistingTags);

        // Delegate suggestion selected event to sub components
        this.on('uiSuggestionsSelected', this.triggerInputEvent);
        this.on('uiSuggestionsSelected', this.triggerDisplayEvent);
        this.on('uiSuggestionsSelected', this.addTagNameToForm);

        // Provide existing tags from markup
        this.provideExistingTags();

        // Conditionally disable input if tag limit reached
        this.checkForMaxTags();
    });
}

exports.default = _flightjs2.default.component(TagEditor, _flightWithChildComponents2.default);

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _flightjs2 = _interopRequireDefault(_flightjs);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function Tags() {
    this.defaultAttrs({
        tagDelete: '[data-delete]',
        tagSelector: '[data-edit-tag]',
        tagTemplate: '[data-tag-template]',
        tagValue: '[data-tag-value]',
        tagSelected: '[data-selected]'
    });

    // Create existing tags, as soon as they are provided by tag-editor component
    this.createExistingTags = function (event, data) {
        var _this = this;

        data.existingTags.forEach(function (tagName) {
            if (tagName.length) {
                var $tag = _this.getNewTag(tagName);
                _this.insertTag($tag);
            }
        });
    };

    // Create a new tag
    this.getNewTag = function (tagName) {
        var $html = (0, _jquery2.default)(this.select('tagTemplate').html());
        $html.find(this.attr.tagValue).text(tagName);
        return $html;
    };

    // Insert tag into tag container
    this.insertTag = function ($tag) {
        this.$node.append($tag);
    };

    // Get data from tag, then delete tag
    this.removeClickedTag = function (event, data) {
        this.removeTag((0, _jquery2.default)(data.el.parentNode).text().trim());
    };

    // Get data from event, then delete tag
    this.removeTagByName = function (event, data) {
        this.removeTag(data.value);
    };

    // Remove tag from tag container and form field as soon as it's clicked
    this.removeTag = function (tagName) {
        var $tag = this.$node.find(':contains(' + tagName + ')');
        $tag.remove();
        this.trigger('uiTagDeleted', {
            tagName: tagName
        });
    };

    // Remove all tags
    this.removeAllTags = function () {
        var self = this;
        this.select('tagSelected').each(function () {
            self.removeTag((0, _jquery2.default)(this).text().trim());
        });
    };

    // Replace all selected tags with new tag list
    this.replaceTags = function (event, data) {
        var self = this;
        var tags = data.tags || [];
        this.select('tagSelector').remove();
        tags.forEach(function (tag) {
            var $tag = self.getNewTag(tag.value);
            self.insertTag($tag);
        });
    };

    // User selected a suggestion
    this.suggestionsSelected = function (event, data) {
        var tagName = data.tagName;
        var $tag = this.getNewTag(tagName);

        this.insertTag($tag);
        this.trigger('uiAddTagNameToForm', {
            tagName: tagName
        });
    };

    this.after('initialize', function () {
        // Create inital tag list in display when existing tags are available
        this.on('uiExistingTagsAvailable', this.createExistingTags);

        // Create a new tag when user made a selections on suggestions list
        this.on('uiSuggestionsSelected', this.suggestionsSelected);

        // Delete tag if another component requests
        this.on(document, 'uiDeactivateFilter', this.removeTagByName);

        // Delete all tags
        this.on(document, 'uiRemoveAllTags', this.removeAllTags);

        // Replace all inputs and tags with new data
        this.on('uiReplaceTags', this.replaceTags);

        // Remove tag from display when user clicks it
        this.on('click', {
            tagDelete: this.removeClickedTag
        });
    });
} // eslint-disable-line no-restricted-imports
exports.default = _flightjs2.default.component(Tags);

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _flightjs2 = _interopRequireDefault(_flightjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function TagInput() {
    this.defaultAttrs({
        currentInputValue: '',
        caseSensitive: null
    });

    // Request suggestion data from data component, passing the input value
    this.requestSuggestionsData = function () {
        if (this.attr.currentInputValue !== this.$node.val()) {
            this.attr.currentInputValue = this.$node.val();

            this.trigger('dataSuggestionsDataRequested', {
                userString: this.userString()
            });
        }
    };

    //
    this.userString = function () {
        if (!this.attr.caseSensitive) {
            this.attr.currentInputValue = this.attr.currentInputValue.toLowerCase();
        }
        return this.attr.currentInputValue;
    };

    // Capture keydown event to capture specific user actions
    this.keyDown = function (event) {
        switch (event.keyCode) {
            // <TAB>: Keep default functionality and reset input field
            case 9:
                this.resetInput();
                break;

            // <RETURN>: Prevent default browser form submit and confirm selected tag
            case 13:
                event.preventDefault();
                this.trigger('uiSuggestionsConfirm');
                break;

            // <ESC>: Reset input field
            case 27:
                event.preventDefault();
                this.resetInput();
                break;

            // <ARROWUP>: Move up in suggestion list
            case 38:
                event.preventDefault();
                this.trigger('uiSuggestionsMoveUp');
                break;

            // <ARROWDOWN>: Move down in suggestion list
            case 40:
                event.preventDefault();
                this.trigger('uiSuggestionsMoveDown');
                break;
            default:
                break;
        }
    };

    // Clear input when user wants to cancel (hits <TAB> or <ESC>)
    this.resetInput = function () {
        this.$node.val('');
        this.attr.currentInputValue = '';
        this.trigger('uiSuggestionsAbort', {
            userString: ''
        });
    };

    // Emmit event that input got focus
    this.inputFocused = function () {
        this.trigger('uiTagInputFocused', {
            userString: this.$node.val()
        });
    };

    this.after('initialize', function () {
        // Capture keyboard events
        this.on('keyup', this.requestSuggestionsData);
        this.on('keydown', this.keyDown);
        this.on('focusin', this.inputFocused);

        // If selection is made reset input
        this.on('uiSuggestionsSelected', this.resetInput);
    });
}

exports.default = _flightjs2.default.component(TagInput);

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _flightjs2 = _interopRequireDefault(_flightjs);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _doT = __webpack_require__(56);

var _doT2 = _interopRequireDefault(_doT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports
function TagSuggestions() {
    this.defaultAttrs({
        tagDivider: '\n',
        allowCreateTag: true,
        disallowDefault: false,

        suggestedTagSelector: '[data-tag-suggestions-item]',
        activeSuggestedTagSelector: '[data-tag-suggestions-item][data-active]',
        suggestionListSelector: '[data-tag-suggestions-list]',
        defaultSuggestedTagSelector: '[data-tag-suggestions-item-default]',

        tagSuggestionsItemTemplateSelector: '[data-tag-suggestions-item-template]',
        tagSuggestionsItemDefaultTemplateSelector: '[data-tag-suggestions-item-default-template]',
        tagSuggestionsItemTemplate: '',
        tagSuggestionsItemDefaultTemplate: ''
    });

    // Hide suggestion container if there is no user input data
    this.hideSuggestions = function (event, data) {
        if (data.userString === '' || !data.userString) {
            this.select('suggestionListSelector').removeAttr('data-active');
        }
    };

    // Show suggestion container if user input data is not empty
    this.showSuggestions = function (event, data) {
        if (data.userString !== '') {
            this.select('suggestionListSelector').attr('data-active', true);
        }
    };

    // Show suggestions in list view
    this.showMatchingSuggestions = function (data) {
        var _this = this;

        var userString = data.userString;
        var suggestions = data.suggestions;
        var existingTags = data.existingTags;

        this.select('suggestionListSelector').html('');

        // Prune existing tags out of suggestions
        existingTags.forEach(function (element) {
            if (_jquery2.default.inArray(element, suggestions) !== -1) {
                suggestions.splice(suggestions.indexOf(element), 1);
            }
        });

        if (userString !== '') {
            suggestions.forEach(function (name) {
                if (userString !== name || _this.attr.disallowDefault) {
                    _this.select('suggestionListSelector').append(_this.getSuggestionMarkup(name));
                }
            });

            var _attr = this.attr,
                disallowDefault = _attr.disallowDefault,
                allowCreateTag = _attr.allowCreateTag;


            if (!disallowDefault) {
                if (!this.isStringInArray(userString, existingTags)) {
                    if (allowCreateTag && !this.isStringInArray(userString, suggestions)) {
                        this.select('suggestionListSelector').append(this.getCreateNewMarkup(userString));
                    } else {
                        this.select('suggestionListSelector').prepend(this.getDefaultSuggestionElement(userString));
                    }
                }
            }

            this.trigger('uiSuggestionsReady', {
                userString: userString
            });
        } else {
            this.trigger('uiSuggestionsEmpty', {
                userString: userString
            });
        }
    };

    // Check if string is in an array
    this.isStringInArray = function (string, array) {
        return _jquery2.default.inArray(string, array) !== -1;
    };

    // Suggestions data served by data component
    this.suggestionsDataServed = function (event, data) {
        this.showMatchingSuggestions(data);
    };

    // List item selected and trigger ui event
    this.suggestionSelected = function (event, data) {
        var tagName = (0, _jquery2.default)(data.el).find('[data-tag-suggestions-item-name]').text().trim();
        this.trigger('uiSuggestionsSelected', {
            tagName: tagName
        });
        this.hideSuggestions(event, data);
    };

    // Create a new suggestion
    this.getSuggestionMarkup = function (name) {
        var templateInput = this.select('tagSuggestionsItemTemplateSelector').html();
        var template = _doT2.default.template(templateInput);
        var templateHtml = template({
            name: name.trim()
        });
        return templateHtml;
    };

    // Create a new suggestion
    this.getCreateNewMarkup = function (name) {
        var templateInput = this.select('tagSuggestionsItemDefaultTemplateSelector').html();
        var template = _doT2.default.template(templateInput);
        var templateHtml = template({
            name: name.trim()
        });
        return templateHtml;
    };

    this.getDefaultSuggestionElement = function (name) {
        var $el = (0, _jquery2.default)('<li class="tag-suggestions__item tag-suggestions__item--new" data-tag-suggestions-item data-tag-suggestions-item-default></li>');
        $el.append((0, _jquery2.default)('<span data-tag-suggestions-item-name></span>').text(name.trim()));
        return $el;
    };

    // Trigger click on current active item if user hits <RETURN>
    this.confirm = function () {
        if (this.select('activeSuggestedTagSelector').length > 0) {
            this.select('activeSuggestedTagSelector').trigger('click');
        } else {
            this.trigger('uiAttemptSelectFromInput');
        }
    };

    // Highlight previous item in suggestion list
    this.moveUp = function () {
        var $suggestions = this.select('suggestedTagSelector');
        var $activeSuggestion = this.select('activeSuggestedTagSelector');

        $activeSuggestion.removeAttr('data-active');

        if ($activeSuggestion.length && $activeSuggestion.prev().length) {
            $activeSuggestion.prev().attr('data-active', true);
        } else {
            $suggestions.last().attr('data-active', true);
        }
    };

    // Highlight next item in suggestion list
    this.moveDown = function () {
        var $suggestions = this.select('suggestedTagSelector');
        var $activeSuggestion = this.select('activeSuggestedTagSelector');

        $activeSuggestion.removeAttr('data-active');

        if ($activeSuggestion.length && $activeSuggestion.next().length) {
            $activeSuggestion.next().attr('data-active', true);
        } else {
            $suggestions.first().attr('data-active', true);
        }
    };

    this.after('initialize', function () {
        // Show / hide list in various situations
        this.on('uiTagInputFocused', this.showSuggestions);
        this.on('uiSuggestionsAbort', this.hideSuggestions);
        this.on('uiSuggestionsReady', this.showSuggestions);
        this.on('uiSuggestionsEmpty', this.hideSuggestions);

        // Execute user keyboard inputs on list
        this.on('uiSuggestionsConfirm', this.confirm);
        this.on('uiSuggestionsMoveUp', this.moveUp);
        this.on('uiSuggestionsMoveDown', this.moveDown);

        // Suggestions data received
        this.on('dataSuggestionsDataServed', this.suggestionsDataServed);

        // Select suggestion when user clicks a list item
        this.on('click', {
            suggestedTagSelector: this.suggestionSelected
        });
    });
} // eslint-disable-line no-restricted-imports
exports.default = _flightjs2.default.component(TagSuggestions);

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function TagSuggestionsData() {
    this.defaultAttrs({
        dataSource: null,
        dataList: '[data-tag-editor-data]',
        dataListItem: '[data-tag-editor-data-item]'
    });

    this.fetchRemoteSuggestions = function (query) {
        var self = this;
        _jquery2.default.ajax({
            url: this.attr.dataSource,
            type: 'GET',
            data: { query: query },
            success: function success(data) {
                self.processSuggestions(data, query);
            },
            error: function error() {
                self.processSuggestions([], query);
            }
        });
    };

    this.getData = function (event, data) {
        var query = data.userString;
        if (query && query.trim()) {
            this.fetchRemoteSuggestions(query);
        } else {
            this.processSuggestions([], '');
        }
    };

    this.processSuggestions = function (suggestions, userString) {
        this.trigger('dataSuggestionsDataServed', {
            userString: userString,
            suggestions: suggestions
        });
    };

    this.after('initialize', function () {
        this.on('dataSuggestionsDataRequested', this.getData);
    });
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(TagSuggestionsData);

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function TagSuggestionsData() {
    this.defaultAttrs({
        dataList: '[data-tag-editor-data]',
        dataListItem: '[data-tag-editor-data-item]',
        caseSensitive: null
    });

    this.fetchSuggestions = function (query) {
        var suggestions = [];
        var self = this;
        this.select('dataListItem').filter(function () {
            return self.filterFunction(this, query);
        }).each(function () {
            suggestions.push((0, _jquery2.default)(this).attr('data-tag-editor-data-item-value'));
        });
        this.processSuggestions(suggestions, query);
    };

    this.filterFunction = function (item, query) {
        var itemTitle = (0, _jquery2.default)(item).attr('data-tag-editor-data-item-display-title');
        var queryTitle = query;
        if (!this.attr.caseSensitive) {
            itemTitle = itemTitle.toLowerCase();
            queryTitle = queryTitle.toLowerCase();
        }
        return itemTitle.indexOf(queryTitle) > -1;
    };

    this.getData = function (event, data) {
        var query = data.userString;
        if (query && query.trim()) {
            this.fetchSuggestions(query);
        } else {
            this.processSuggestions([], '');
        }
    };

    this.processSuggestions = function (suggestions, userString) {
        this.trigger('dataSuggestionsDataServed', {
            userString: userString,
            suggestions: suggestions
        });
    };

    this.after('initialize', function () {
        this.on('dataSuggestionsDataRequested', this.getData);
    });
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(TagSuggestionsData);

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var withHistory = function withHistory() {
    this.isHistoryApiSupported = function () {
        return !!(window.history && history.pushState);
    };

    /**
     * This fires a 'uiHistoryPopped' event upon an onpopstate
     * event on the window object.
     *
     * To address the issue of invalid onpopstate event fired on page load in Webkit browsers, it
     * requires that the current history state has an attribute of 's' of value true. Setting
     * state.s = true marks a page/state as reachable by clicking browser's back button.
     *
     */
    this.registerPopstateListener = function () {
        var existingPopStateListener = window.onpopstate;
        window.onpopstate = function () {
            if (window.history.state && window.history.state.s === true) {
                if (existingPopStateListener) {
                    existingPopStateListener();
                }
                this.trigger('uiHistoryPopped');
            }
        }.bind(this);
    };

    this.initializeHistory = function () {
        if (this.isHistoryApiSupported()) {
            this.registerPopstateListener();

            /*
             On initial page load, i.e. user click back button from a different page or user load
             page using browser address bar, the current state is set to null to mark that this
             page is not affected by any onpopstate the browser may or may not fire upon page load.
             */
            window.history.replaceState(null, window.document.title, window.location.href);
        }
    };

    this.pushHistory = function (url) {
        if (this.isHistoryApiSupported()) {
            /*
             Before navigating to a different state, we mark the current state/page reachable by
             back button by assigning state.s == true
             */
            if (!history.state || !history.state.s) {
                window.history.replaceState({ s: true }, window.document.title, window.location.href);
            }

            window.history.pushState({ s: true }, window.document.title, url);
        }
    };
};

exports.default = withHistory;

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function SmallScreenOffCanvasFilters() {
    this.defaultAttrs({
        close: '[data-close]',
        form: '[data-small-screen-off-canvas-filters-form]',
        item: '[data-small-screen-off-canvas-filters-item]',

        button: '[data-small-screen-off-filters-button]',

        input: '[data-small-screen-off-canvas-filters-input]',
        section: '[data-small-screen-off-canvas-filters-section]',
        back: '[data-small-screen-off-canvas-filters-section-back]'
    });

    this.after('initialize', function () {
        this.on('click', {
            close: this.deactivate,
            item: this.selectItem,
            button: this.activateSection,
            back: this.deactivateSection
        });

        this.on(document, 'uiActivateSmallScreenOffCanvasFilters', this.activate);
    });

    this.activate = function (e, data) {
        if (data.name === this.$node.attr('data-small-screen-off-canvas-filters-name')) {
            this.$node.attr('data-active', '');
        }
    };

    this.deactivate = function () {
        this.$node.removeAttr('data-active');
        this.select('section').attr('data-small-screen-off-canvas-filters-section-active', 'false');
    };

    this.activateSection = function (e, data) {
        var name = (0, _jquery2.default)(data.el).attr('data-small-screen-off-filters-button-name');
        var $el = (0, _jquery2.default)('[data-small-screen-off-canvas-filters-section-name="' + name + '"]');
        $el.attr('data-small-screen-off-canvas-filters-section-active', 'true');
    };

    this.deactivateSection = function (e, data) {
        var $el = (0, _jquery2.default)(data.el).parents('[data-small-screen-off-canvas-filters-section]');
        $el.attr('data-small-screen-off-canvas-filters-section-active', 'false');
    };

    this.selectItem = function (e, data) {
        e.preventDefault();
        var value = (0, _jquery2.default)(data.el).attr('data-value');

        var $section = (0, _jquery2.default)(data.el).parents(this.attr.section);

        if (value && $section.find('[value=' + value + ']').length) {
            $section.find('[value=' + value + ']').remove();
            this.select('input').remove();
        } else {
            var $input = $section.find(this.attr.input);
            $input.val(value);
        }
        this.select('form').submit();
    };
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(SmallScreenOffCanvasFilters);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// doT.js
// 2011-2014, Laura Doktorova, https://github.com/olado/doT
// Licensed under the MIT license.

(function () {
	"use strict";

	var doT = {
		name: "doT",
		version: "1.1.1",
		templateSettings: {
			evaluate:    /\{\{([\s\S]+?(\}?)+)\}\}/g,
			interpolate: /\{\{=([\s\S]+?)\}\}/g,
			encode:      /\{\{!([\s\S]+?)\}\}/g,
			use:         /\{\{#([\s\S]+?)\}\}/g,
			useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
			define:      /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
			defineParams:/^\s*([\w$]+):([\s\S]+)/,
			conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
			iterate:     /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
			varname:	"it",
			strip:		true,
			append:		true,
			selfcontained: false,
			doNotSkipEncoded: false
		},
		template: undefined, //fn, compile template
		compile:  undefined, //fn, for express
		log: true
	}, _globals;

	doT.encodeHTMLSource = function(doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	};

	_globals = (function(){ return this || (0,eval)("this"); }());

	/* istanbul ignore else */
	if (typeof module !== "undefined" && module.exports) {
		module.exports = doT;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return doT;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		_globals.doT = doT;
	}

	var startend = {
		append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
		split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
	}, skip = /$^/;

	function resolveDefs(c, block, def) {
		return ((typeof block === "string") ? block : block.toString())
		.replace(c.define || skip, function(m, code, assign, value) {
			if (code.indexOf("def.") === 0) {
				code = code.substring(4);
			}
			if (!(code in def)) {
				if (assign === ":") {
					if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
						def[code] = {arg: param, text: v};
					});
					if (!(code in def)) def[code]= value;
				} else {
					new Function("def", "def['"+code+"']=" + value)(def);
				}
			}
			return "";
		})
		.replace(c.use || skip, function(m, code) {
			if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
				if (def[d] && def[d].arg && param) {
					var rw = (d+":"+param).replace(/'|\\/g, "_");
					def.__exp = def.__exp || {};
					def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
					return s + "def.__exp['"+rw+"']";
				}
			});
			var v = new Function("def", "return " + code)(def);
			return v ? resolveDefs(c, v, def) : v;
		});
	}

	function unescape(code) {
		return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
	}

	doT.template = function(tmpl, c, def) {
		c = c || doT.templateSettings;
		var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
			str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;

		str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
					.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
			.replace(/'|\\/g, "\\$&")
			.replace(c.interpolate || skip, function(m, code) {
				return cse.start + unescape(code) + cse.end;
			})
			.replace(c.encode || skip, function(m, code) {
				needhtmlencode = true;
				return cse.startencode + unescape(code) + cse.end;
			})
			.replace(c.conditional || skip, function(m, elsecase, code) {
				return elsecase ?
					(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
					(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
			})
			.replace(c.iterate || skip, function(m, iterate, vname, iname) {
				if (!iterate) return "';} } out+='";
				sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
				return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
					+vname+"=arr"+sid+"["+indv+"+=1];out+='";
			})
			.replace(c.evaluate || skip, function(m, code) {
				return "';" + unescape(code) + "out+='";
			})
			+ "';return out;")
			.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
			.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
			//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

		if (needhtmlencode) {
			if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
			str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
				+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
				+ str;
		}
		try {
			return new Function(c.varname, str);
		} catch (e) {
			/* istanbul ignore else */
			if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
			throw e;
		}
	};

	doT.compile = function(tmpl, def) {
		return doT.template(tmpl, null, def);
	};
}());


/***/ })

},[1193]);


// WEBPACK FOOTER //
// page/discover-designs-3db4bbd4ace0179ac50e.js